import { FC } from 'react'
import Gradient from '../platform/Gradient'

interface ProfileBannerBackgroundProps {
  color: string
}

const ProfileBanner: FC<{ color: string }> = ({ color }) => {
  const palette = ['#FAFAF6', color || '#EFF3FF']
  return <Gradient options={{ colorPalette: palette }} css={{ height: '180px' }} />
}

export default ProfileBanner
